import { render } from "./header.vue?vue&type=template&id=12a06331&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=12a06331&scoped=true&lang=css"

import exportComponent from "C:\\AOTCHRON\\AOTCHRON\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a06331"]])

export default __exports__